// extracted by mini-css-extract-plugin
export default {"properties":"PropertiesTab_properties__sxlgc","propertyLine":"PropertiesTab_propertyLine__TJ2dS"};